import React, { Component } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Divider,
  IconButton,
  FormControlLabel,
  Checkbox,
  DialogTitle
} from '@mui/material';
import { Close, Add, Inventory } from '@mui/icons-material';

import AdminAPI from '../service/AdminAPI';

class CreateProductPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fixedValues: true
    };
  }

  handleShow = (title) => this.setState({ show: true, title });

  handleClose = () => {
    this.props.onClose();
  }

  handleSubmit = (ev) => {
    AdminAPI.CreateProduct({
      name: ev.target.name.value,
      price: ev.target.price ? ev.target.price.value : 0,
      weight: ev.target.weight ? ev.target.weight.value : 0,
      isFixed: ev.target.isFixed.checked,
      isPublished: ev.target.isPublished.checked
    })
      .then(() => {
        window.location.reload();
      })
      .catch(console.error);

    ev.preventDefault();
  }

  render() {
    return (
      <Dialog
        open={this.props.show}
        onClose={this.handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: { xs: '12px', sm: '20px' },
            overflow: 'hidden',
            margin: { xs: '16px', sm: '32px' },
            maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }
          }
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={this.handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'white',
            zIndex: 1,
            '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
          }}
        >
          <Close />
        </IconButton>

        {/* Header with gradient */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
            pt: { xs: 3, sm: 4 },
            pb: { xs: 2.5, sm: 3 },
            px: { xs: 2, sm: 3 },
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1.5, sm: 2 }
          }}
        >
          <Inventory sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
          <DialogTitle sx={{ p: 0, flex: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
              Erstelle ein Produkt
            </Typography>
          </DialogTitle>
        </Box>

        <DialogContent sx={{ pt: { xs: 2, sm: 3 }, pb: { xs: 1, sm: 2 }, px: { xs: 2, sm: 3 } }}>
          <Box component="form" onSubmit={this.handleSubmit} id="create-product-form">
            <TextField
              fullWidth
              label="Name des Produkts"
              name="name"
              placeholder="Name des Produkts..."
              sx={{ mb: 3 }}
            />

            <FormControlLabel
              control={<Checkbox name="isPublished" />}
              label="Soll dieses Produkt veröffentlicht werden?"
              sx={{ mb: 2 }}
            />

            <FormControlLabel
              control={
                <Checkbox 
                  name="isFixed"
                  checked={this.state.fixedValues} 
                  onChange={() => this.setState({ fixedValues: !this.state.fixedValues })}
                />
              }
              label="Hat dieses Produkt ein fixiertes Gewicht und somit einen fixierten Preis?"
              sx={{ mb: 3 }}
            />

            {this.state.fixedValues && (
              <Box>
                <TextField
                  fullWidth
                  type="number"
                  label="Gewicht (Kg/L)"
                  name="weight"
                  placeholder="Gewicht eingeben..."
                  inputProps={{ step: "0.01", min: "0" }}
                  sx={{ mb: 2 }}
                />

                <TextField
                  fullWidth
                  type="number"
                  label="Preis (€)"
                  name="price"
                  placeholder="Preis eingeben..."
                  inputProps={{ step: "0.01", min: "0" }}
                />
              </Box>
            )}
          </Box>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ 
          p: { xs: 2, sm: 3 }, 
          gap: { xs: 1.5, sm: 2 },
          flexDirection: { xs: 'column', sm: 'row' }
        }}>
          <Button
            onClick={this.handleClose}
            variant="outlined"
            size="large"
            fullWidth
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              borderColor: '#ddd',
              color: '#666',
              fontSize: { xs: '0.9rem', sm: '1rem' },
              py: { xs: 1.2, sm: 1.5 },
              order: { xs: 2, sm: 1 },
              '&:hover': {
                borderColor: '#bbb',
                bgcolor: '#f5f5f5'
              }
            }}
          >
            Schließen
          </Button>
          <Button
            type="submit"
            form="create-product-form"
            variant="contained"
            size="large"
            fullWidth
            startIcon={<Add />}
            sx={{
              bgcolor: '#2e7d32',
              color: 'white',
              fontWeight: 600,
              textTransform: 'none',
              fontSize: { xs: '0.9rem', sm: '1rem' },
              py: { xs: 1.2, sm: 1.5 },
              borderRadius: '10px',
              boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
              order: { xs: 1, sm: 2 },
              '&:hover': {
                bgcolor: '#1b5e20',
                boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                transform: 'translateY(-2px)'
              },
              transition: 'all 0.2s ease'
            }}
          >
            Hinzufügen
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default CreateProductPopup;
